import classNames from "classnames/bind";
import styles from "./SidebarMobile.module.scss";
import MenuItem from "./Menu/MenuItem";
import { dataMenuClient } from "../../../utils/constants/data";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRectangleXmark } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { URL } from "../../../routes/url";
import { ReactComponent as BarsIcon } from "../../../assets/icons/bars.svg";
import SearchMobile from "../SearchMobile/SearchMobile";
const cx = classNames.bind(styles);

function SidebarMobile() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const navigateToPage = (path: string) => {
    setIsMenuOpen(false); // Đóng menu trước khi chuyển trang
    navigate(path); // Chuyển trang sử dụng React Router
  };
  return (
    <>
      <input
        type="checkbox"
        className={cx("nav__input")}
        name=""
        id="nav-mobile-input"
        checked={isMenuOpen}
        onChange={toggleMenu} // Khi bạn bấm input checkbox, trạng thái của menu sẽ thay đổi
      />
      <div className={cx("nav_mobile")}>
        <label className={cx("nav__bars-btn2")} htmlFor="nav-mobile-input">
          <FontAwesomeIcon
            icon={faRectangleXmark}
            className={cx("icon-bars")}
          />
        </label>{" "}
        <nav className={cx("navWrapper")}>
          <div className={cx("icon-close")}>
            <label
              style={isMenuOpen ? { display: "none" } : undefined}
              className={cx("nav__bars-btn")}
              htmlFor="nav-mobile-input">
              <BarsIcon className={cx("icon-bars")} />
            </label>

            <SearchMobile />
          </div>
          <div className={cx("title")}>
            <h3>DEV BETTER</h3>
          </div>
          <div className={cx("btn-auth")}>
            <Link className={cx("btn")} to={URL.CLIENT.REGISTER}>
              Đăng ký
            </Link>
            <Link className={cx("btn")} to={URL.CLIENT.LOGIN}>
              Đăng nhập
            </Link>
          </div>
          {dataMenuClient.map((item: any, index: number) => {
            return (
              <div key={index}>
                <MenuItem
                  title={item.title}
                  to={item.to}
                  icon={item.icon}
                  handleNavigate={() => navigateToPage(item.to)}
                />
              </div>
            );
          })}
        </nav>
      </div>
    </>
  );
}

export default SidebarMobile;
